import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@/components/Button'
import Input from '@/components/Input'

interface MagicLinkSigninProps {
  onMagicLinkSignin: (email: string) => Promise<boolean>
}
export default function MagicLinkSignin({ onMagicLinkSignin }: MagicLinkSigninProps) {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [isPending, setIsPending] = useState(false)

  async function handleMagicLinkRequest() {
    setIsPending(true)
    await onMagicLinkSignin(email)
    setIsPending(false)
  }

  return (
    <div className='flex flex-col gap-4 justify-center items-center h-full'>
      <div className='w-full'>
        <Input
          type='email'
          label={t('content.components.input_contact.email_field_title')}
          value={email}
          onInput={setEmail}
        />
      </div>

      <Button
        variant={'cta'}
        label={t('content.components.signin.magiclink.button_title')}
        fullwidth
        onClick={handleMagicLinkRequest}
        disabled={!email || isPending}
      />
      <div className='text-xs text-gray-700 mt-2'>{t('content.components.signin.magiclink.subtitle')}</div>
    </div>
  )
}
